import { create } from "zustand"

interface AppVersionState {
  version: string | null
  osType: "android" | "ios" | null
  setAppVersion: (version: string, osType: "android" | "ios") => void
}

export const useAppVersionStore = create<AppVersionState>((set) => ({
  version: null,
  osType: null,
  setAppVersion: (version: string, osType: "android" | "ios") =>
    set({ version, osType }),
}))
